import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function AdminRowMenu({
  anchorEl,
  target,
  onClose,
  onEdit,
  onReset,
  onDeactivate,
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MenuItem onClick={() => onEdit(target)}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onReset(target)}>
        <ListItemIcon>
          <LockResetIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Reset Password</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onDeactivate(target)}>
        <ListItemIcon>
          {target?.is_active ? (
            <BlockIcon fontSize="small" color="error" />
          ) : (
            <CheckCircleIcon fontSize="small" color="success" />
          )}
        </ListItemIcon>
        <ListItemText
          sx={{ color: target?.is_active ? "error.main" : "success.main" }}
        >
          {target?.is_active ? "Deactivate" : "Reactivate"}
        </ListItemText>
      </MenuItem>
    </Menu>
  );
}
